import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a33bfe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "global-sidebar--wrapper"
}
const _hoisted_2 = { class: "short-profile" }
const _hoisted_3 = {
  key: 0,
  class: "c-primary-grey"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("PROFILE")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("BILLING")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("FTP SETTINGS")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("FORMS")
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleModal = _resolveComponent("SimpleModal")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["full-height", { hijacking: _ctx.hijackingToken }])
  }, [
    (_ctx.showModalLogOut)
      ? (_openBlock(), _createBlock(_component_SimpleModal, {
          key: 0,
          title: "Log out?",
          subtitle: "Are you sure you want to quit?",
          buttons: _ctx.buttons,
          onAction: _ctx.handleActionModal,
          onClose: _ctx.closeLogOutModal
        }, null, 8, ["buttons", "onAction", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.profile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["global-sidebar", { hijacking: _ctx.hijackingToken }])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Avatar, {
                class: "m-bottom-5",
                size: 96
              }),
              _createElementVNode("h2", null, _toDisplayString(_ctx.profile.first_name) + " " + _toDisplayString(_ctx.profile.last_name), 1),
              (_ctx.profile.company_name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.profile.company_name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("nav", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "profile",
                  replace: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "billing",
                  replace: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "ftp",
                  replace: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "forms",
                  replace: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                (_ctx.profile.is_staff)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.urlAdmin,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, "ADMIN", 8, _hoisted_8))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: "link-button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModalLogOut = true))
                }, "LOG OUT")
              ])
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["settings-wrapper", { hijacking: _ctx.hijackingToken }])
    }, [
      _createVNode(_component_router_view)
    ], 2)
  ], 2))
}